import { useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Container, Paper, Title, Text, Stack, Button } from '@mantine/core';
import { IconMailCheck } from '@tabler/icons-react';
import { notifications } from '@mantine/notifications';
import { authService } from '../../services/auth';
import { Logo } from '../../components/common';

export default function VerifyEmailSent() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') ?? '';
  const [resending, setResending] = useState(false);

  const handleResend = async () => {
    setResending(true);
    try {
      await authService.resendVerificationEmail(email);
      notifications.show({
        title: 'Email sent',
        message: 'Check your inbox for the verification link.',
        color: 'green',
      });
    } catch {
      notifications.show({
        title: 'Error',
        message: 'Failed to resend verification email.',
        color: 'red',
      });
    } finally {
      setResending(false);
    }
  };

  return (
    <Container size={420} my={40}>
      <Stack align="center" mb="lg">
        <Logo size="lg" />
      </Stack>

      <Paper withBorder shadow="md" p={30} radius="md">
        <Stack align="center" gap="md">
          <IconMailCheck size={48} color="var(--mantine-color-blue-6)" />
          <Title order={3}>Check your email</Title>
          <Text c="dimmed" ta="center">
            We sent a verification link to{' '}
            {email ? <strong>{email}</strong> : 'your email address'}.
            Click it to activate your account.
          </Text>

          <Button
            variant="subtle"
            loading={resending}
            onClick={handleResend}
            disabled={!email}
          >
            Resend verification email
          </Button>

          <Text size="sm" c="dimmed">
            Already verified?{' '}
            <Text component={Link} to="/login" size="sm" c="blue" style={{ textDecoration: 'none' }}>
              Log in
            </Text>
          </Text>
        </Stack>
      </Paper>
    </Container>
  );
}
